/* ============================================================
   EVEXIA — Offre « 1 Achetée = 1 OFFERTE » (auto).
   Chargé globalement (defer) depuis layout/theme.liquid.

   PRINCIPE (simple et robuste)
   ----------------------------
   Sur les produits en offre, le SÉLECTEUR DE QUANTITÉ démarre directement
   à 2 (minimum 2, par pas de 2). Le client voit donc « 2 boîtes » dès le
   départ ; la remise automatique BXGY « achète 1 = 1 offerte » en rend une
   sur deux gratuite. Pas d'ajout caché qui pourrait être écrasé par une app
   de panier (Kraken) ou de commande (EasySell).

   FILET DE SÉCURITÉ (panier)
   --------------------------
   Si un ajout arrive malgré tout en quantité impaire (autre point d'entrée),
   on relit /cart.js après chaque changement et on force une quantité PAIRE
   sur les lignes en offre :
     • « + » (impair vers le haut) → pair supérieur (2 → 4)
     • « − » (impair vers le bas)  → pair inférieur (4 → 2)
     • « − » depuis 2 → 0 → ligne retirée.
   Après correction, on notifie les apps de panier (Kraken, Dawn) pour un
   re-render.

   PRODUITS EN OFFRE : par ID de VARIANTE (liste ci-dessous).
   >>> Pour ajouter un futur produit : ajouter l'ID de sa variante ici
       (et créer sa remise BXGY côté Shopify).
   ============================================================ */
(function () {
  'use strict';
  if (window.__evxBogoCartInit) return;
  window.__evxBogoCartInit = true;

  /* --- Variantes concernées par l'offre 1 = 1 offerte --- */
  var BOGO_VARIANT_IDS = {
    '49524631830839': 1, /* Bétaïne HCl, Pepsine & Gentiane */
    '50748967616823': 1, /* Rhodiola & Safran */
    '47488769130807': 1, /* Fatigavex */
    '44536353816887': 1, /* Juvexia Cheveux et Ongles */
    '47791039545655': 1, /* Anti Acné Evexia */
    '50239262818615': 1  /* Curcumine Evexia */
  };

  function isBogoVariant(id) {
    if (id == null) return false;
    return BOGO_VARIANT_IDS[String(id).trim()] === 1;
  }

  /* ============================================================
     1) SÉLECTEUR DE QUANTITÉ À 2 SUR LES PAGES PRODUIT EN OFFRE
     ============================================================ */

  /* Variante actuellement affichée sur la page produit. */
  function currentPageVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]')
      || document.querySelector('.product-variant-id')
      || document.querySelector('[name="id"]');
    return input && input.value ? input.value : null;
  }

  /* Force un input quantité produit à 2 / min 2 / pas 2, et garantit le
     pas de 2 même si le thème ne respecte pas l'attribut step. */
  function forceQtyInput(input) {
    if (!input) return;
    try {
      input.min = '2';
      input.setAttribute('min', '2');
      input.step = '2';
      input.setAttribute('step', '2');
      input.setAttribute('data-min', '2');
      var v = parseInt(input.value, 10);
      if (!v || v < 2) {
        input.value = '2';
        try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }
      bindQtySnap(input);
    } catch (e) {}
  }

  /* Garantit une valeur PAIRE ≥ 2 sur le sélecteur produit, en respectant
     le sens (+ monte au pair supérieur, − descend au pair inférieur, min 2).
     Filet si le stepper du thème avance de 1 en 1. */
  function bindQtySnap(input) {
    if (input.__evxSnap) return;
    input.__evxSnap = true;
    input.__evxPrev = Math.max(2, parseInt(input.value, 10) || 2);
    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      var out;
      if (isNaN(v) || v < 2) out = 2;
      else if (v % 2 === 1) out = (v > input.__evxPrev) ? v + 1 : v - 1;
      else out = v;
      if (out < 2) out = 2;
      input.__evxPrev = out;
      if (String(out) !== String(input.value)) {
        input.value = String(out);
        try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }
    });
  }

  /* Applique la quantité 2 si la variante affichée est en offre.
     N'agit que sur les inputs quantité du FORMULAIRE PRODUIT
     (name="quantity") — jamais sur le panier (name="updates[...]"). */
  function applyBogoQty() {
    var vid = currentPageVariantId();
    if (!isBogoVariant(vid)) return;
    var inputs = document.querySelectorAll(
      'form[action*="/cart/add"] input[name="quantity"], .quantity__input[name="quantity"]'
    );
    for (var i = 0; i < inputs.length; i++) forceQtyInput(inputs[i]);
  }

  /* ============================================================
     2) FILET DE SÉCURITÉ PANIER — quantité paire sur les lignes en offre
     ============================================================ */
  var EVX_HEADER = 'X-EVX-BOGO-FIX';
  var FIXING = false;
  var timer = null;
  var lastKnown = {};

  function rootUrl() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    return r.replace(/\/$/, '');
  }

  /* Quantité cible d'une ligne en offre : toujours PAIRE, jamais sous 2.
     (Le retrait complet passe par la corbeille, qui envoie quantité 0.) */
  function targetQty(cur, prev) {
    cur = parseInt(cur, 10) || 0;
    if (cur <= 0) return 0;                        /* déjà retirée */
    if (cur % 2 === 0) return cur < 2 ? 2 : cur;   /* paire → OK (plancher 2) */
    if (typeof prev !== 'number') return cur + 1;  /* inconnu → pair supérieur */
    if (cur > prev) return cur + 1;                /* augmentation → pair supérieur */
    return Math.max(2, cur - 1);                   /* diminution → pair inférieur, jamais < 2 */
  }

  function schedule(delay) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(checkCart, delay || 250);
  }

  function checkCart() {
    if (FIXING) { schedule(400); return; }
    fetch(rootUrl() + '/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var seen = {};
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (!isBogoVariant(it.variant_id)) continue;
          seen[it.key] = true;
          var t = targetQty(it.quantity, lastKnown[it.key]);
          if (t !== it.quantity) { fixLine(i + 1, t); return; }
          lastKnown[it.key] = it.quantity;
        }
        for (var k in lastKnown) { if (!seen[k]) delete lastKnown[k]; }
      })
      .catch(function () {});
  }

  function fixLine(line, qty) {
    FIXING = true;
    var headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    };
    headers[EVX_HEADER] = '1';
    fetch(rootUrl() + '/cart/change.js', {
      method: 'POST',
      headers: headers,
      credentials: 'same-origin',
      body: JSON.stringify({
        line: line,
        quantity: qty,
        sections: 'cart-drawer,cart-icon-bubble,cart-notification-product'
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) { rerender(response); })
      .catch(function () {})
      .then(function () {
        FIXING = false;
        notifyCartRefreshed();
        schedule(300);
      });
  }

  function rerender(response) {
    if (document.querySelector('cart-items')) { window.location.reload(); return; }
    if (response && response.sections) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && response.sections['cart-drawer']) {
        try {
          var tmp = document.createElement('div');
          tmp.innerHTML = response.sections['cart-drawer'];
          var inner = tmp.querySelector('.drawer__inner');
          var current = drawer.querySelector('.drawer__inner');
          if (inner && current) current.innerHTML = inner.innerHTML;
        } catch (e) {}
      }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && response.sections['cart-icon-bubble']) {
        try {
          var tmp2 = document.createElement('div');
          tmp2.innerHTML = response.sections['cart-icon-bubble'];
          var el2 = tmp2.querySelector('.shopify-section') || tmp2;
          bubble.innerHTML = el2.innerHTML;
        } catch (e) {}
      }
    }
  }

  function notifyCartRefreshed() {
    var events = ['cart:refresh', 'cart:updated', 'cart-updated', 'cartUpdated', 'cart:build', 'cart:change'];
    events.forEach(function (name) {
      try { document.dispatchEvent(new CustomEvent(name, { bubbles: true })); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent(name, { bubbles: true })); } catch (e) {}
    });
    try {
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'evx-bogo' });
      }
    } catch (e) {}
  }

  var RE_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function isOwnHeaders(h) {
    try {
      if (!h) return false;
      if (typeof h.get === 'function') return h.get(EVX_HEADER) === '1';
      return h[EVX_HEADER] === '1';
    } catch (e) { return false; }
  }

  /* Interception fetch : planifie une vérification après toute mutation. */
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = '';
      try { url = (typeof input === 'string') ? input : ((input && input.url) || ''); } catch (e) {}
      var own = isOwnHeaders((init && init.headers) || (input && typeof input !== 'string' && input.headers));
      var p = origFetch.apply(this, arguments);
      if (RE_MUTATION.test(url) && !own) { p.then(function () { schedule(250); }, function () {}); }
      return p;
    };
  }

  /* Interception XHR : idem (apps qui mettent fetch en cache). */
  try {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__evxUrl = url || '';
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      var url = this.__evxUrl || '';
      if (RE_MUTATION.test(url)) {
        try { this.addEventListener('load', function () { schedule(250); }); } catch (e) {}
      }
      return origSend.apply(this, arguments);
    };
  } catch (e) {}

  /* Filet universel : tout clic peut être un ajout d'une app. */
  document.addEventListener('click', function () {
    setTimeout(function () { schedule(400); }, 500);
  }, true);

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    /* Quantité 2 : plusieurs passages (la page peut se construire de façon
       asynchrone, et Dawn re-render le bloc quantité). */
    applyBogoQty();
    setTimeout(applyBogoQty, 600);
    setTimeout(applyBogoQty, 1500);
    setTimeout(applyBogoQty, 3000);

    /* Ré-applique si la variante change (sélecteur de variante). */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'id') setTimeout(applyBogoQty, 50);
    });

    /* Filet panier au chargement. */
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
          if (evt && evt.source === 'evx-bogo') return;
          schedule(250);
        });
      } catch (e) {}
    }
    schedule(400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();